export default "__VITE_ASSET__BMDDAiSs__"